export default "__VITE_ASSET__BjnwIKzW__"